export const itemLeft = [
    {
        to: '/',
        desc: 'BERANDA'
    },
    {
        to: '/#tentang_kami',
        desc: 'TENTANG KAMI'
    },
]

export const itemRight = [
    {
        to: '/artikel-berita',
        desc: 'ARTIKEL & BERITA'
    },
    {
        to: '/tk',
        desc: 'TK'
    },
    {
        to: '/mi',
        desc: 'MI'
    },
    {
        to: '/mts',
        desc: 'MTS'
    },
    // {
    //     to: '/ppdb',
    //     desc: 'PPDB'
    // }
]